export default {
  nav: {
    home: 'Hjem',
    categories: 'Kategorier',
    guide: 'Guide',
    review: 'Anmeldelse',
    shipping: 'Fragt',
    safety: 'Sikkerhed',
    faq: 'FAQ',
    cta: 'Besøg hovedsiden',
    shoppingGuide: 'Indkøbsguide',
  },
  hero: {
    badge: 'Opdateret til 2026 · Uafhængig ressource',
    title: 'AllChinaBuy Spreadsheet — Find produkter, links og QC-valg hurtigere',
    subtitle:
      'Udforsk de nyeste AllChinaBuy spreadsheet-ressourcer, produktfund, nyttige links, QC-information, købsguides og fragtressourcer samlet ét sted.',
    ctaPrimary: 'AllChinaBuy Spreadsheet',
    ctaSecondary: 'Køb nu',
    searchPlaceholder: 'Søg produkter, kategorier eller guides...',
  },
  categories: {
    title: 'Populære kategorier',
    subtitle: 'Gå direkte til de produkter og links, du har brug for, i hovedarket.',
    dropdownLabel: 'Gennemse efter kategori',
    dropdownPlaceholder: 'Vælg en kategori',
    visit: 'Se på hovedsiden',
  },
  cat: {
    shoes: 'Sko',
    hoodies: 'Hættetrøjer / Sweatshirts',
    tshirts: 'T-shirts',
    jackets: 'Jakker',
    pants: 'Bukser / Shorts',
    headwear: 'Hovedbeklædning',
    sets: 'Sæt',
    underwear: 'Undertøj',
    jersey: 'Trøje',
    accessories: 'Tilbehør',
    bags: 'Tasker',
    belts: 'Bælter',
    perfumes: 'Parfumer',
    other: 'Andre ting',
  },
  info: {
    sectionTitle: 'Alt om AllChinaBuy Spreadsheet',
    whatTitle: 'Hvad er AllChinaBuy Spreadsheet?',
    whatBody:
      'AllChinaBuy-arket er en kurateret samling af produktfund, fungerende links, QC-billeder og fragtnoter samlet i ét organiseret ark. I stedet for at grave gennem endeløse tråde åbner købere et enkelt ark for at se varer inden for sko, hættetrøjer, t-shirts, jakker, tasker og mere — hver række viser produktet, dets link, prisniveau og kvalitetskontrolstatus.',
    howTitle: 'Sådan fungerer det',
    howBody:
      'Åbn arket, vælg en kategori fra rullemenuen eller gitteret, og gå til den vare, du ønsker. Hvert produkt linker direkte til hovedbutikken, så du kan tjekke detaljer, sammenligne muligheder og afgive en ordre på få klik. Layoutet er bygget til hastighed: find varen, tjek QC-billedet, kopiér linket, færdig.',
    reviewTitle: 'Hvorfor købere elsker det',
    reviewBody:
      'Brugere vender hele tiden tilbage til arket, fordi det sparer timers søgning og fjerner gætteriet. Den mest nyttige version kombinerer ægte køberfeedback med opdaterede QC-billeder, så du ved, hvad du får, før du betaler. Det er et researchværktøj, ikke en butik — det endelige køb sker på hovedsiden.',
    shippingTitle: 'Fragtpris & lager',
    shippingBody:
      'Fragtprisen afhænger af varen, dens vægt og den fragtlinje, du vælger. Arket grupperer varer efter kategori, så du kan sammenligne lignende produkter og planlægge en samlet ordre for at sænke fragten pr. vare. Tjek lager- og fragtsektionerne for aktuelle metoder og spare-tips.',
    qcTitle: 'QC & produktinspektion',
    qcBody:
      'Kvalitetskontrol er det trin, der beskytter din ordre. Kig efter ark, der inkluderer QC-billeder, mål og sælgernoter, før du forpligter dig. Hvis en annonce ingen QC-data har, skal du behandle den med forsigtighed og bede sælgeren om billeder først.',
    safetyTitle: 'Sikkerhedscenter',
    safetyBody:
      'Dette er en uafhængig informationsressource og er ikke tilknyttet eller drevet af AllChinaBuy. Pas på falske ark og phishing-links. Brug kun links, der kommer fra hovedsiden, og indtast aldrig dine login- eller betalingsoplysninger på ukendte sider.',
  },
  article: {
    badge: 'Komplet guide',
    title: 'AllChinaBuy Spreadsheet: Komplet guide til fund, links og QC',
    desc:
      'En fuld gennemgang af, hvad AllChinaBuy-arket er, hvad der er i det, hvordan man bruger det, og hvordan man sikkert tjekker produkter, før man bestiller.',
    cta: 'Læs hele guiden',
    readTime: '8 min læsning',
    updated: 'Sidst opdateret',
  },
  faq: {
    title: 'Ofte stillede spørgsmål',
    q1: 'Er AllChinaBuy Spreadsheet gratis at bruge?',
    a1: 'Arket er en gratis informationsressource. Du kan gennemse kategorier og links her, og det endelige køb sker på hovedsiden.',
    q2: 'Er dette websted tilknyttet AllChinaBuy?',
    a2: 'Nej. Dette er en uafhængig informationsressource. Vi er ikke tilknyttet eller drevet af AllChinaBuy.',
    q3: 'Hvordan tjekker jeg QC for et produkt?',
    a3: 'Kig efter QC-billeder, mål og sælgernoter i annoncen. Hvis et produkt ingen QC-data har, så bed sælgeren om billeder, før du bestiller.',
    q4: 'Hvordan reducerer jeg fragtomkostningerne?',
    a4: 'Saml flere varer i én ordre, vælg en passende fragtlinje og sammenlign lignende produkter i samme kategori, før du forpligter dig.',
    q5: 'Er produktlinksene sikre?',
    a5: 'Brug kun links, der kommer fra hovedsiden. Undgå tredjeparts- eller forkortede links, og indtast aldrig login- eller betalingsoplysninger på ukendte sider.',
  },
  footer: {
    about:
      'En uafhængig informationsressource for AllChinaBuy Spreadsheet-fund, links, QC-billeder og fragtguides. Vi er ikke tilknyttet eller drevet af AllChinaBuy.',
    linksTitle: 'Hurtige links',
    categoriesTitle: 'Kategorier',
    disclaimer:
      'Dette er en uafhængig informationsressource og er ikke tilknyttet eller drevet af AllChinaBuy.',
    rights: 'Alle rettigheder forbeholdes.',
  },
  pillar: {
    title: 'Pillar-guides og dybdegående artikler',
    subtitle: 'Originale, dybdegående guides til at købe smartere og sikrere med AllChinaBuy-arket.',
    read: 'Læs guiden',
  },
  guide: {
    notFound: 'Guide ikke fundet',
    notFoundDesc: 'Den guide, du leder efter, findes ikke. Gå tilbage til forsiden for at gennemse alle guider.',
    ctaTitle: 'Klar til at gennemse de nyeste fund?',
    ctaDesc: 'Udforsk hver kategori og gå direkte til produkterne på hovedsiden.',
    related: 'Relaterede guider',
  },
  common: {
    explore: 'Udforsk',
    learnMore: 'Lær mere',
    backHome: 'Tilbage til forsiden',
    readArticle: 'Læs guiden',
  },
};